<template>
  <component :is="tag">
    <slot />
  </component>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  export default defineNuxtComponent({
    name: 'TheHeading',
    props: {
      level: {
        type: Number as PropType<number>,
        required: true,
      },
    },

    computed: {
      tag(): string {
        return `h${this.level}`;
      },
    },
  });
</script>
